import { render, staticRenderFns } from "./CampaignReport.vue?vue&type=template&id=64e86e5d&scoped=true&"
import script from "./CampaignReport.vue?vue&type=script&lang=js&"
export * from "./CampaignReport.vue?vue&type=script&lang=js&"
import style0 from "./CampaignReport.vue?vue&type=style&index=0&id=64e86e5d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e86e5d",
  null
  
)

export default component.exports